import {Component, OnInit} from '@angular/core';
import {CommonService} from '../../services/common/common.service';

@Component({
  selector: 'app-header-lite',
  templateUrl: './header-lite.component.html',
  styleUrls: ['../../app.component.scss', './header-lite.component.scss']
})
export class HeaderLiteComponent implements OnInit {
  constructor(public commonService: CommonService) {
  }

  ngOnInit() {
  }
}
